import React, { useState } from "react";
import { Button, Divider, Drawer } from "antd";
import { Rate } from "antd";
import {
  HomeOutlined,
  EnvironmentOutlined,
  ShopOutlined,
  CheckOutlined,
} from "@ant-design/icons";

interface OrderCardProps {
  type: string; // e.g. "$42.99"
}

const PastOrdersDetails = ({ type }: OrderCardProps) => {
  const [tasteRating, setTasteRating] = useState<number>(0);
  const [deliveryRating, setDeliveryRating] = useState<number>(0);

  return (
    <div className="order-drawer-body">
      {type === "rate" && (
        <>
          <div
            style={{
              maxWidth: 600,

              padding: 20,
            }}
          >
            {/* Ratings */}
            <div style={{ marginBottom: 20, display: "flex", gap: "25px" }}>
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: 18,
                  marginBottom: 8,
                }}
              >
                Taste:
              </div>
              <Rate
                onChange={(value) => setTasteRating(value)}
                value={tasteRating}
                style={{ color: "#C32340" }}
              />
            </div>

            <div style={{ marginBottom: 20, display: "flex", gap: "25px" }}>
              <div
                style={{
                  fontFamily: "Inter",
                  fontWeight: 600,
                  fontSize: 18,
                  marginBottom: 8,
                }}
              >
                Delivery:
              </div>
              <Rate
                onChange={(value) => setDeliveryRating(value)}
                value={deliveryRating}
                style={{ color: "#C32340" }}
              />
            </div>

            {/* Submit Button */}
            <Button
              type="primary"
              style={{
                background: "#C32340",
                border: "none",
                color: "#fff",
                fontWeight: 600,
                marginBottom: 20,
              }}
              block
            >
              Submit
            </Button>
          </div>

          <div
            style={{
              background: "rgba(195, 35, 64, 0.05)",
            }}
          >
            <div
              style={{
                padding: "15px 20px",
                position: "relative",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <img
                  src={"/User/fork.svg"}
                  alt={"fork"}
                  style={{
                    marginRight: 12,
                  }}
                />
                <div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    Restaurant Name
                  </div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: 14,
                      opacity: 0.7,
                    }}
                  >
                    123 Food Street, Downtown
                  </div>
                </div>
              </div>

              <div
                style={{
                  borderLeft: "2px dotted #000000",
                  height: 40,
                  margin: 12,
                }}
              ></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <EnvironmentOutlined
                    style={{
                      fontSize: 35,
                      color: "#000000",
                      marginRight: 10,
                    }}
                  />
                  <div>
                    <div
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Home
                    </div>
                    <div
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: 14,
                        opacity: 0.7,
                      }}
                    >
                      456 Maple Avenue, Uptown
                    </div>
                  </div>
                </div>
              </div>
              <Divider />

              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <CheckOutlined
                  style={{
                    fontSize: 28,
                    color: "green",
                    marginRight: 12,
                  }}
                />
                <div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: 16,
                      color: "green",
                    }}
                  >
                    Restaurant Nam
                  </div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: 14,
                      opacity: 0.7,
                    }}
                  >
                    123 Food Street, Downtown
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
      {type === "help" && (
        <>
          <div
            style={{
              maxWidth: 600,

              padding: 20,
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginBottom: "25px",
              }}
            >
              <img
                src={"/User/fork.svg"}
                alt={"fork"}
                style={{
                  marginRight: 12,
                }}
              />
              <div>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: 16,
                  }}
                >
                  Restaurant Name
                </div>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: 14,
                    opacity: 0.7,
                  }}
                >
                  123 Food Street, Downtown
                </div>
              </div>
            </div>
            <div style={{ display: "flex", alignItems: "flex-start" }}>
              <CheckOutlined
                style={{
                  fontSize: 28,
                  color: "green",
                  marginRight: 12,
                }}
              />
              <div>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 600,
                    fontSize: 16,
                    color: "green",
                  }}
                >
                  Restaurant Nam
                </div>
                <div
                  style={{
                    fontFamily: "Inter",
                    fontWeight: 500,
                    fontSize: 14,
                    opacity: 0.7,
                  }}
                >
                  123 Food Street, Downtown
                </div>
              </div>
            </div>
          </div>

          <div
            style={{
              background: "rgba(195, 35, 64, 0.05)",
            }}
          >
            <div
              style={{
                padding: "15px 20px",
                position: "relative",
              }}
            >
              <Button
                type="primary"
                style={{
                  background: "#fff",
                  border: "1px solid #C32340",
                  color: "#C32340",
                  fontWeight: 600,
                  marginBottom: 20,
                }}
                block
              >
                Email
              </Button>
              <Button
                type="primary"
                style={{
                  background: "#C32340",
                  border: "none",
                  color: "#fff",
                  fontWeight: 600,
                  marginBottom: 20,
                }}
                block
              >
                Call Us
              </Button>
            </div>
          </div>
        </>
      )}

      {
        type === "details" && (
            <>
            <div
              style={{
                padding: "15px 20px",
                position: "relative",
              }}
            >
              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <img
                  src={"/User/fork.svg"}
                  alt={"fork"}
                  style={{
                    marginRight: 12,
                  }}
                />
                <div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: 16,
                    }}
                  >
                    Restaurant Name
                  </div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: 14,
                      opacity: 0.7,
                    }}
                  >
                    123 Food Street, Downtown
                  </div>
                </div>
              </div>

              <div
                style={{
                  borderLeft: "2px dotted #000000",
                  height: 40,
                  margin: 12,
                }}
              ></div>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 20,
                }}
              >
                <div style={{ display: "flex", alignItems: "flex-start" }}>
                  <EnvironmentOutlined
                    style={{
                      fontSize: 35,
                      color: "#000000",
                      marginRight: 10,
                    }}
                  />
                  <div>
                    <div
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 600,
                        fontSize: 16,
                      }}
                    >
                      Home
                    </div>
                    <div
                      style={{
                        fontFamily: "Inter",
                        fontWeight: 500,
                        fontSize: 14,
                        opacity: 0.7,
                      }}
                    >
                      456 Maple Avenue, Uptown
                    </div>
                  </div>
                </div>
              </div>
              <Divider />

              <div style={{ display: "flex", alignItems: "flex-start" }}>
                <CheckOutlined
                  style={{
                    fontSize: 28,
                    color: "green",
                    marginRight: 12,
                  }}
                />
                <div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 600,
                      fontSize: 16,
                      color: "green",
                    }}
                  >
                    Restaurant Nam
                  </div>
                  <div
                    style={{
                      fontFamily: "Inter",
                      fontWeight: 500,
                      fontSize: 14,
                      opacity: 0.7,
                    }}
                  >
                    123 Food Street, Downtown
                  </div>
                </div>
              </div>

              <Divider/>
              <div style={{marginBottom:"20px"}}>Your Order - 2 Items</div>

              <div className="detail-orders">
                <div>
                   <div className="order-name-price" style={{marginBottom:"15px"}}>
                    <span> 1 X </span>
                    <span>Chicken Cheese Burrito</span>
                   </div>
                   <div className="single-price" style={{margin:"10px 30px"}}>$8.50</div>
                </div>
                <div className="order-name-price" >
                    $8.50
                </div>
              </div>
            </div>

            <div
            style={{
              background: "rgba(195, 35, 64, 0.05)",
            }}
          >
            <div
              style={{
                padding: "15px 20px",
                position: "relative",
              }}
            >
              <div className="detail-orders order-name-price">
                <div className="single-price">Items Cost</div>
                <div className="single-price">$20.5</div>
              </div>
              <div className="detail-orders">
                <div className="single-price">Taxes</div>
                <div className="single-price">$20.5</div>
              </div>
              <div className="detail-orders single-price">
                <div className="single-price">Tip</div>
                <div className="single-price">$20.5</div>
              </div>
              <div className="detail-orders single-price">
                <div className="single-price">Delivery Fees</div>
                <div className="single-price">$20.5</div>
              </div>
              <Divider/>

              <div className="detail-orders ">
                <div className="order-name-price">Delivery Fees</div>
                <div className="order-name-price">$20.5</div>
              </div>

            </div>
          </div>
            </>
        )
      }
    </div>
  );
};

export default PastOrdersDetails;
